import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { routes } from '../../routes';

class Header extends Component {
  render() {
    return (
      <nav className="navbar navbar-expand-md navbar-light">
        <div className="container">
          <div className="row">
            <div className="col" />
            <div className="brand-col col">
              <Link className="navbar-brand Sage Financial Solutions" to={routes.findProfessional} />
            </div>
            <div className="col"></div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Header;
